module.exports = __webpack_public_path__ + "2707db3cdd8c8a2dbf64f9172d0bfa47.png";


//////////////////
// WEBPACK FOOTER
// ./components/profile-header/src/img/practice-bg.png
// module id = 2188
// module chunks = 0